import React, {Component} from 'react';

export default class AnswerButton extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            timeLeft: 0
        }
        this.intervalId = null;
        this.time = parseInt(this.props.time) || 0;
        this.onClick = this.props.click;
        this.message = this.props.message;
    }

    componentDidMount() {
        this.startTimer();
    }

    startTimer() {
        if(this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }

        if(this.time <= 0) {
            return;
        }

        this.setState({...this.state, timeLeft: this.time});

        this.intervalId = setInterval(()=>{
            const timeLeft = this.state.timeLeft - 1;

            if(timeLeft === 0) {
                clearInterval(this.intervalId);
                this.intervalId = null;
                this.onClick();
                return;
            }

            this.setState({...this.state, timeLeft: timeLeft});

        }, 1000);
    }

    componentWillUnmount() {
        if(this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    render() {
        if(this.time <= 0) {
            return (
                <button className="button" onClick={this.onClick}>{this.message}</button>
            );
        }

        if(!this.intervalId) {
            return null;
        }

        return (
            <button className="button" onClick={this.onClick}>{this.message} ({this.state.timeLeft})</button>
        )
    }
}
